var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-sidebar" },
    [
      _vm._m(0),
      _c(
        "a-menu",
        {
          staticClass: "container-sidebar-content",
          attrs: { "open-keys": _vm.menus.open, mode: "inline" },
          on: {
            "update:openKeys": function ($event) {
              return _vm.$set(_vm.menus, "open", $event)
            },
            "update:open-keys": function ($event) {
              return _vm.$set(_vm.menus, "open", $event)
            },
            click: _vm.handleClick,
          },
          model: {
            value: _vm.menus.selected,
            callback: function ($$v) {
              _vm.$set(_vm.menus, "selected", $$v)
            },
            expression: "menus.selected",
          },
        },
        [
          _vm._l(_vm.menus.list, function (menu) {
            return [
              menu.children && menu.children.length > 0
                ? _c(
                    "a-sub-menu",
                    { key: menu.path },
                    [
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(menu.name)),
                      ]),
                      _vm._l(menu.children, function (item) {
                        return _c("a-menu-item", { key: item.path }, [
                          _c("span", [_vm._v(" " + _vm._s(item.name) + " ")]),
                        ])
                      }),
                    ],
                    2
                  )
                : _c("a-menu-item", { key: menu.path }, [
                    _c("span", [_vm._v(" " + _vm._s(menu.name) + " ")]),
                  ]),
            ]
          }),
        ],
        2
      ),
      _c("div", { staticClass: "container-sidebar-footer" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-sidebar-title" }, [
      _c("div", { staticClass: "container-sidebar-title__content" }, [
        _c("span", [_vm._v(" 监测管理 ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }